import React from 'react'
import { t } from 'ttag'

import { Form } from 'components/shared/Form/Form'

import { MESSAGE_FIELD, SENDER_FIELD, SUBJECT_FIELD } from './model'

export const MessageTemplateManagementForm = ({
  control,
  formState,
  variables,
}) => (
  <Form>
    <Form.Field
      error={formState.errors[SENDER_FIELD]?.message}
      field="input"
      label={t`Sender`}
      name={SENDER_FIELD}
      {...{ control }}
    />
    <Form.Field
      error={formState.errors[SUBJECT_FIELD]?.message}
      field="input"
      label={t`Subject`}
      name={SUBJECT_FIELD}
      {...{ control }}
    />
    <Form.Field
      error={
        formState.errors?.root?.apiError?.message?.body[0] ||
        formState.errors[MESSAGE_FIELD]?.message
      }
      field="editor"
      hint={t`Use variables to personalize the message. Available variables: company, deadline, full name, url.`}
      label={t`Message`}
      name={MESSAGE_FIELD}
      {...{ control, variables }}
    />
  </Form>
)
